import { useEffect, useState } from "react";
import { useParams } from "react-router";

import { validateNewDevice } from "@api";
import { Container } from "@molecules";
import { Message } from "@templates";

export default function NewDevice() {
  const { token } = useParams();
  const [result, setResult] = useState(null);

  useEffect(() => {
    validateNewDevice({ token })
      .then((data) => {
        console.log("Response:", data);
        setResult(true);
      })
      .catch((error) => {
        console.log("Error:", error);
        setResult(false);
      });
  }, [token]);

  return result === null ? (
    <div class="header header-home">
      <div>
        <div class="loader">Loading...</div>
      </div>
    </div>
  ) : result ? (
    <Container>
      <Message>
        <Message.Emoji>🎉</Message.Emoji>
        <Message.Title>¡Listo!</Message.Title>
        <Message.Body>
          Ya podés volver a la app para seguir operando desde tu nuevo
          dispositivo.
        </Message.Body>
      </Message>
    </Container>
  ) : (
    <Container>
      <Message>
        <Message.Emoji>🤕</Message.Emoji>
        <Message.Title>¡Uy! El link ya no anda</Message.Title>
        <Message.Body>
          Volvé a la app para iniciar sesión nuevamente.
        </Message.Body>
      </Message>
    </Container>
  );
}
